module.exports = __webpack_public_path__ + "static/img/cup-animation.69b3db8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/SVG-filer/cup-animation.gif
// module id = gNAA
// module chunks = 1